import type { ComponentProps } from 'react';
import { Button } from '@helios/ui';
import { GoogleProjectMap } from './GoogleProjectMap';
import { useGoogleMapsRuntime } from './mapsConfiguration.hooks';

export function ConfiguredGoogleProjectMap(props: ComponentProps<typeof GoogleProjectMap>) {
  const runtime = useGoogleMapsRuntime();
  if (runtime.isPending)
    return (
      <p role="status" className="text-muted-foreground p-4 text-sm">
        Loading project map settings…
      </p>
    );
  if (runtime.error || !runtime.configuration)
    return (
      <div role="alert" className="space-y-2 p-4 text-sm">
        <p>{runtime.error?.message ?? 'Your role cannot load project map settings.'}</p>
        <Button size="sm" variant="outline" onClick={() => void runtime.refetch()}>
          Retry map settings
        </Button>
      </div>
    );
  return (
    <GoogleProjectMap
      {...props}
      configuration={runtime.configuration}
      cities={runtime.configuration.allowApproximateGeocoding ? props.cities : []}
    />
  );
}
